import ReactDOM from 'react-dom';

import React, {useState} from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {BrowserRouter as Router, Link, Route, Switch} from "react-router-dom";

import InfoPopup from './util/InfoPopup.js';
import Impressum from "./Impressum";
import Login from "./Login";
import Datenschutz from "./Datenschutz";
import {Header} from "./Header";
import {Authorized} from "./Authorized";


/*
application home
*/

const KairosApp = ({

}) => {
	// info handling
	const [info, setInfo] = useState();

	const showInfo = (title, message, footer) => setInfo({
		title: title,
		message: message,
		footer: footer,
	});

	const showHideInfo = {
		show: showInfo,
		hide: () => setInfo(),
	};

	// error handling
	const showError = msg => showInfo('Fehler:', msg);

	return (
		<Router>
			{/* info */}
			{info &&
			<InfoPopup
				title = {info.title}
				message = {info.message}
				footer = {info.footer}
				onHide = {() => {
					// if (info.onHide)
					// 	info.onHide();
					setInfo();
				}}/>
			}

			{/* header & main */}
			<Container fluid id = {'ui-root'} className = {'p-4'}>
				<Switch>
					{/* login */}
					<Route path = {'/login'}>
						<Header/>
						<Row className = {'my-3'}>
							<Col>
								<Login
									onSuccess = {() => window.location.assign('/')}
									onError = {showError}/>
							</Col>
						</Row>
					</Route>

					{/* imprint */}
					<Route path = {'/impressum'}>
						<Header/>
						<Impressum/>
					</Route>

					{/* privacy */}
					<Route path = {'/datenschutz'}>
						<Header/>
						<Datenschutz/>
					</Route>

					{/* app */}
					<Route>
						<Authorized
							showInfo = {showHideInfo}
							showError = {showError}/>
					</Route>
				</Switch>
			</Container>

			{/* footer */}
			<Container fluid className = {'mt-auto flex-shrink-0 my-1'}>
				<Row className = {'mx-1'}>
					<Col className = {'kairos-footer d-flex'}>
						<Link to = {'/impressum'} className = {'mr-5'}>
							{'Impressum'}
						</Link>
						<Link to = {'/datenschutz'} className = {'mr-5'}>
							{'Datenschutz'}
						</Link>
						<div className = {'ml-auto'}>{'Kairos Software nach Hoksys® 2014-2026'}</div>
					</Col>
				</Row>
			</Container>
		</Router>
	);
};

export default KairosApp;

// render

ReactDOM.render(
	<KairosApp/>,
	document.getElementById('app')
);
